import web from '../img/web2.jpg';
import mobile from '../img/mobile.jpg';
import ui from '../img/ui.png';
import SectionHeading from './SectionHeading';
import useReveal from './useReveal';

const services = [
  {
    image: ui,
    alt: 'Professional graphic design services',
    title: 'Graphics Design',
    text: "We craft memorable visual identities that communicate your brand's essence. Our designs create instant recognition and emotional connections with your audience across all platforms.",
  },
  {
    image: web,
    alt: 'Custom website development solutions',
    title: 'Websites That Perform',
    text: 'We build strategic websites designed to engage visitors and drive business growth. Every site we create delivers seamless experiences across all user devices and browsers.',
  },
  {
    image: mobile,
    alt: 'Custom mobile application development',
    title: 'Mobile Experiences',
    text: 'We develop intuitive mobile apps that solve real problems and keep users engaged. Our solutions work flawlessly across iOS and Android platforms.',
  },
];

function Servicesminatechnologies() {
  const ref = useReveal();

  return (
    <div ref={ref} className="section-pad bg-surface-2">
      <div className="wrap">
        <SectionHeading
          eyebrow="Services"
          title={<>Everything you need to <span className="text-gradient">grow online</span></>}
          lede="From brand identity to production-ready web and mobile apps, one team takes your idea all the way to launch."
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {services.map((service, index) => (
            <article
              key={service.title}
              className="reveal card card-lift flex flex-col p-3"
              data-reveal
              style={{ '--d': `${index * 80}ms` }}
            >
              <div className="zoom-media overflow-hidden rounded-media">
                <img src={service.image} alt={service.alt} className="aspect-[16/10] w-full object-cover" />
              </div>
              <div className="flex flex-1 flex-col p-4 pt-6">
                <span className="font-display text-sm font-semibold text-brand">0{index + 1}</span>
                <h3 className="display-md mt-2 text-ink">{service.title}</h3>
                <p className="mt-3 text-[0.98rem] text-muted">{service.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Servicesminatechnologies;
